import { useEffect } from "react";
import Cookies from "js-cookie";

export const useSetPreferredRegion = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const query = new URLSearchParams(window.location.search);
    const region = query.get("region");

    if (!region) return;
    // Ensure region is either "sg" or "nonsg"
    if (region !== "sg" && region !== "nonsg") return;

    Cookies.set("preferred_region", region.toUpperCase());
  }, []);
};
